import { useEffect } from 'react';
import MainLayout from './MainLayout';
import PrintButton from './PrintButton';
import { events, logAmpEvent } from '../utils/Amplitude';

export default function LegalDocPage({
  pageTitle,
  pageDescription,
  titleText,
  docID,
  lang,
  hideNavAndFooter,
  hideSiteTitle = false,
  hidePrintButton = false,
  docNameForAmplitude,
}) {
  useEffect(() => logAmpEvent(events.USER_VIEWED_LEGAL_DOC_PAGE, {
    Document: docNameForAmplitude,
  }), []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    document.body.classList.add('legalDoc');
    return () => document.body.classList.remove('legalDoc');
  }, []);

  return (
    <MainLayout
      title={pageTitle}
      description={pageDescription}
      showNavBar={!hideNavAndFooter}
      isLandingPage={hideSiteTitle}
      showFooter={!hideNavAndFooter}
    >
      <div className="legalDocHeaderCont">
        <h1>{titleText}</h1>
        {hidePrintButton || (
          <PrintButton
            color="white"
            fill="solid"
            ampProp={{ Document: docNameForAmplitude }}
            ariaLabelKey="ButtonDescription_PrintPage"
            documentID={docID[lang].PRINTID}
          />
        )}
      </div>
      <div className="legalDociFrameContainer">
        <iframe title={pageTitle} src={`https://docs.google.com/document/d/e/${docID[lang].PUBLISHEDID}/pub?embedded=true`} frameBorder="0" border="0" cellSpacing="0" />
      </div>
    </MainLayout>
  );
}
